import httpClient from './httpClient';

const API_BASE_URL = '/autorizaciones';

export const autorizacionService = {
  // Obtener todas las autorizaciones con filtros
  async obtenerAutorizaciones(filtros = {}) {
    try {
      const params = new URLSearchParams();
      
      // Agregar filtros como parámetros de consulta
      if (filtros.empresa_id) params.append('empresa_id', filtros.empresa_id);
      if (filtros.tipo) params.append('tipo', filtros.tipo);
      if (filtros.estado) params.append('estado', filtros.estado);
      if (filtros.empleado_id) params.append('empleado_id', filtros.empleado_id);
      if (filtros.fecha_inicio) params.append('fecha_inicio', filtros.fecha_inicio);
      if (filtros.fecha_fin) params.append('fecha_fin', filtros.fecha_fin);

      const queryString = params.toString();
      const url = queryString ? `${API_BASE_URL}?${queryString}` : API_BASE_URL;
      
      const response = await httpClient.get(url);
      return response.data;
    } catch (error) {
      console.error('Error al obtener autorizaciones:', error);
      throw error;
    }
  },

  // Obtener autorización por ID
  async obtenerAutorizacion(id) {
    try {
      const response = await httpClient.get(`${API_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al obtener autorización:', error);
      throw error;
    }
  },

  // Crear nueva autorización
  async crearAutorizacion(data) {
    try {
      const response = await httpClient.post(API_BASE_URL, data);
      return response.data;
    } catch (error) {
      console.error('Error al crear autorización:', error);
      throw error;
    }
  },

  // Actualizar autorización
  async actualizarAutorizacion(id, data) {
    try {
      const response = await httpClient.put(`${API_BASE_URL}/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error al actualizar autorización:', error);
      throw error;
    }
  },

  // Eliminar autorización
  async eliminarAutorizacion(id) {
    try {
      const response = await httpClient.delete(`${API_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error al eliminar autorización:', error);
      throw error;
    }
  },

  // Aprobar autorización
  async aprobarAutorizacion(id, comentarios = '') {
    try {
      const response = await httpClient.put(`${API_BASE_URL}/${id}/aprobar`, {
        comentarios
      });
      return response.data;
    } catch (error) {
      console.error('Error al aprobar autorización:', error);
      throw error;
    }
  },

  // Rechazar autorización
  async rechazarAutorizacion(id, comentarios = '') {
    try {
      const response = await httpClient.put(`${API_BASE_URL}/${id}/rechazar`, {
        comentarios
      });
      return response.data;
    } catch (error) {
      console.error('Error al rechazar autorización:', error);
      throw error;
    }
  },

  // Marcar como pendiente
  async marcarPendiente(id, comentarios = '') {
    try {
      const response = await httpClient.put(`${API_BASE_URL}/${id}/pendiente`, {
        comentarios
      });
      return response.data;
    } catch (error) {
      console.error('Error al marcar como pendiente:', error);
      throw error;
    }
  },



  // Métodos de utilidad para filtros
  filtros: {
    // Filtrar por tipo de autorización
    porTipo(tipo, empresaId = 1) {
      return this.obtenerAutorizaciones({ empresa_id: empresaId, tipo });
    },

    // Filtrar por estado
    porEstado(estado, empresaId = 1) {
      return this.obtenerAutorizaciones({ empresa_id: empresaId, estado });
    },

    // Filtrar por empleado
    porEmpleado(empleadoId, empresaId = 1) {
      return this.obtenerAutorizaciones({ empresa_id: empresaId, empleado_id: empleadoId });
    },

    // Filtrar por rango de fechas
    porRangoFechas(fechaInicio, fechaFin, empresaId = 1) {
      return this.obtenerAutorizaciones({ 
        empresa_id: empresaId, 
        fecha_inicio: fechaInicio, 
        fecha_fin: fechaFin 
      });
    },

    // Obtener autorizaciones pendientes
    pendientes(empresaId = 1) {
      return this.obtenerAutorizaciones({ empresa_id: empresaId, estado: 'pendiente' });
    },

    // Obtener horas extra por subtipo
    horasExtraPorSubtipo(subTipo, empresaId = 1) {
      return this.obtenerAutorizaciones({ 
        empresa_id: empresaId, 
        tipo: 'horas-extra'
      }).then(response => {
        if (response.success) {
          const filtradas = response.data.filter(auth => auth.sub_tipo === subTipo);
          return { ...response, data: filtradas };
        }
        return response;
      });
    }
  }
};

export default autorizacionService; 